import FetchApi from "./api";
import config from "../config";

const serviceSending = {
  sendText: (payload) =>
    FetchApi(`${config.urls.apiBaseUrl}api/GPT/TextChat`, "POST", payload),
  sendFile: (payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/GPT/UploadVoice`,
      "POST",
      payload
    ),
  deleteChatByID: (avatarID) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/GPT/DeleteChatByCharacterId/${avatarID}`,
      "DELETE"
    ),
};

export default serviceSending;
